// msalClient.ts
import { PublicClientApplication, Configuration, PopupRequest } from "@azure/msal-browser";
import env from '@app/env.json';
const isLocalhost = ['localhost'].includes(window.location.hostname);

interface MsalWeb {
  localhostClientIDMsal?: string;
  clientIDMsal: string;
  redirectURLMsal?: string;
}

interface Msal {
  authoritymsal: string;
  msalWeb: MsalWeb;
}


const { msal} = env;
const { msalauthority, msalweb} = msal;
const {localhostClientIDMsal, clientIDMsal, redirectURLMsal} = msalweb;

const msalConfig: Configuration = {
  auth: {
    authority: msalauthority,
    clientId: isLocalhost ? localhostClientIDMsal : clientIDMsal,
    redirectUri: `${window.location.origin}/auth`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
};

console.log('MSAL Config:', msalConfig);
export const msalInstance = new PublicClientApplication(msalConfig);

// Web logout method
export const msalWebLogout = async (): Promise<void> => {
  try {
    console.log('MSAL Web: Initiating logout');
    await msalInstance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin + '/login',
    });
  } catch (error) {
    console.error('MSAL Web logout error:', error);
    // Fallback: force redirect to login
    window.location.replace('/login');
    throw error;
  }
};

export { msalConfig };